import React, { useContext } from 'react'
import makeStyles from '@mui/styles/makeStyles';
import { FormControl, MenuItem, InputLabel, TextField } from '@mui/material'
import { DataRoomsContext } from './Contexts'
import { LoadingDotsIcon } from './Icons'
import { useNavigate, useParams } from 'react-router'

const selectWidth = 300

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 20,
  },
  label: {
    top: '-9px',
    fontSize: '16px',
  },
  labelShrunk: {
    display: 'none',
  },
  loadingLabel: {
    minWidth: selectWidth,
    top: '-6px',
    height: '20px',
  },
  select: {
    backgroundColor: theme.palette.background.default,
    borderRadius: 4,
    marginTop: -2,
    minWidth: selectWidth,
  },
  dataRoomLabel: {
    fontSize: "16px",
  }
}))

export default function SelectDataRoom() {
  const classes = useStyles()
  const { dataRooms, refreshNext, loading, triggerRefresh } = useContext(DataRoomsContext)
  const { dataRoomKey = '' } = useParams()

  const navigate = useNavigate();

  const pickRoom = async event => {
    if (refreshNext) {
      await triggerRefresh()
    }
    navigate(`../${event.target.value}`)
  }

  return (
    <div className={classes.root}>
      {dataRooms && <FormControl variant='outlined' margin='dense'>
        {loading && <InputLabel classes={{root: classes.loadingLabel, shrink: classes.labelShrunk}} ><LoadingDotsIcon size={6} vPadding={6} hPadding={6} /></InputLabel>}
        {!dataRoomKey && !loading && <InputLabel classes={{root: classes.label, shrink: classes.labelShrunk}}>Select Data Room</InputLabel>}
        <TextField className={classes.select} value={dataRoomKey && !loading ? dataRoomKey : ''} onChange={pickRoom} select SelectProps={{ style: { maxHeight: '40px', paddingTop: '2px' } }} >
          {dataRooms.map(({data_room, data_room_display_name, light}) => (
            <MenuItem value={data_room} key={data_room}>
              <span className={classes.dataRoomLabel}>{data_room_display_name} {light && <span style={{ fontStyle: 'italic' }}> Light</span>}</span>
            </MenuItem>
          ))}
        </TextField>
      </FormControl>}
    </div>
  )
}
